export function removeTypename(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map(removeTypename);
  } else if (obj && typeof obj === 'object') {
    const { __typename, ...rest } = obj;
    return Object.fromEntries(Object.entries(rest).map(([k, v]) => [k, removeTypename(v)]));
  }
  return obj;
}
